export const text = {
  Academy: "Academy",
  CategoryName: "Categorienaam",
  ChapterNo: "Hoofdstuknummer",
  Lesson: "Les",
  CourseName: "Cursusnaam",
  Category: "Categorie",
  LessonNo: "Lesnummer",
  Course: "Cursus",
  AddCategory: "Categorie toevoegen",
  AddCourse: "Cursus toevoegen",
  AddLesson: "Les toevoegen",
  AddChapter: "Hoofdstuk toevoegen",
  Courses: "Cursus",
  Lesson: "Les",
  Chapter: "Hoofdstuk",
  SelectMediaType: "Selecteer mediatype",
  Video: "Video",
  Image: "Afbeelding",
  Categoryaddedsuccessfully: "Categorie succesvol toegevoegd",
  Anattachmentisrequired: "Een bijlage is verplicht",
  Categoryupdatedsuccessfully: "Categorie succesvol bijgewerkt",
  CategoryDeletedsuccessfully: "Categorie succesvol verwijderd",
  Chapteraddedsuccessfully: "Hoofdstuk succesvol toegevoegd!",
  PleaseaddQuestiontoyourChapter: "Voeg een vraag toe aan uw hoofdstuk",
  Chapterupdatedsuccessfully: "Hoofdstuk succesvol bijgewerkt",
  ChapterDeletedsuccessfully: "Hoofdstuk succesvol verwijderd",
  Courseaddedsuccessfully: "Cursus succesvol toegevoegd",
  Courseupdatedsuccessfully: "Cursus succesvol bijgewerkt",
  CourseDeletedsuccessfully: "Cursus succesvol verwijderd",
  AssignCourseToTeam: "Cursus toewijzen aan team",
  AssignCourseToTeamupdatedsuccessfully:
    "Cursus succesvol bijgewerkt voor team",
  AssignCourseToTeamAddedsuccessfully: "Cursus succesvol toegewezen aan team",
  Assignto: "Toewijzen aan",
  Lessonaddedsuccessfully: "Les succesvol toegevoegd",
  Lessonupdatedsuccessfully: "Les succesvol bijgewerkt",
  LessonDeletedsuccessfully: "Les succesvol verwijderd",
};
